import React from 'react';
import Modal from '../../shared/Modal';
import Text from '../../shared/Text';
import styles from '../../../utility/styles';
import Switch from 'react-bootstrap/Switch';
import styled from 'styled-components';
import Container from 'react-bootstrap/Container';
import Spinner from '../../shared/Spinner';

const StyledSwitch = styled(Switch)`
    display: flex;
    margin-left: 8px;
    & .form-check-input {
        cursor: pointer;
        height: 32px;
        width: 48px;
        background-color: ${styles.colors.lightGray};
        border-color: ${styles.colors.lightGray};
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3.5' fill='%23fff'/%3e%3c/svg%3e");
        &:checked {
            background-color: ${styles.colors.success};
            border-color: ${styles.colors.success};
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3.5' fill='%23fff'/%3e%3c/svg%3e");
        }
		@media only screen and (max-width: 375px) {
			height: 24px;
			width: 36px;
		}
    }
`

const BlankButton = styled.button`
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	background: none;
	border: none;
	padding: 0;
	margin: 0;
	box-shadow: none;
	color: inherit;
	font: inherit;
	cursor: pointer;
	text-align: inherit;
	border-radius: 0;
`

const BigRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 16px 0;
`

const Row = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
`

const TeslaIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.8623 4.74121C13.8623 4.74121 17.0472 4.80584 20.2178 6.27734C19.4133 7.49088 17.8176 8.08786 17.7939 8.09668C17.68 7.02358 16.926 6.76074 14.5234 6.76074L12.0068 20.9287L9.47656 6.76074C7.09538 6.76074 6.33434 7.0236 6.22754 8.09668C6.21474 8.09193 4.61096 7.49502 3.80371 6.27734C6.97423 4.80592 10.1592 4.74121 10.1592 4.74121L12.0107 6.99707L13.8623 4.74121ZM12 3C14.6517 3.01422 17.7227 3.45518 21 4.74902C20.997 4.75785 20.8877 5.07895 20.4951 5.79395C17.4951 4.48592 14.5592 4.06656 12 4.08789C9.44081 4.07367 6.50482 4.48568 3.50488 5.80078C3.14946 5.14679 3 4.75586 3 4.75586C6.28435 3.45492 9.35546 3.01422 12 3Z" fill="white" />
    </svg>
)

const RivianIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.4871 11.28C20.4395 10.2 14.7722 4.359 13.7097 3.51525C13.3385 3.2178 12.857 3 12.263 3C11.669 3 11.1861 3.2178 10.8162 3.51525C9.75423 4.359 4.08198 10.2 3.03798 11.28C2.94798 11.379 3.02988 11.5329 3.15858 11.5329L5.62638 11.5347C5.88378 11.5347 5.96028 11.4897 6.12228 11.316L7.08978 10.2774C8.11443 9.17265 10.6133 6.73365 11.5268 5.96505C11.8697 5.67615 12.258 5.68605 12.2634 5.68605C12.2688 5.68605 12.6572 5.67705 13.0001 5.96505C13.9136 6.73005 16.4124 9.17355 17.4371 10.2774L18.4046 11.316C18.5666 11.4897 18.6431 11.5347 18.9005 11.5347L21.3683 11.5329C21.497 11.5338 21.5726 11.3785 21.4871 11.28ZM3.03798 12.6763C4.08558 13.7563 9.75288 19.6028 10.8149 20.4461C11.1857 20.7431 11.6627 20.9613 12.2616 20.9613C12.8606 20.9613 13.3385 20.7435 13.7084 20.4461C14.7704 19.6028 20.4381 13.7568 21.4857 12.6763C21.5757 12.5773 21.4938 12.4234 21.3651 12.4234C20.8418 12.4234 19.6281 12.4216 18.8978 12.4216C18.6404 12.4216 18.5639 12.4667 18.4019 12.6404L17.4344 13.6785C16.4097 14.7832 13.9109 17.2222 12.9974 17.9908C12.6545 18.2797 12.2661 18.2698 12.2607 18.2698C12.2553 18.2698 11.867 18.2788 11.5241 17.9908C10.6106 17.2258 8.11173 14.7823 7.08708 13.6785L6.11958 12.6404C5.95758 12.4667 5.88108 12.4216 5.62368 12.4216L3.15588 12.4234C3.02898 12.4234 2.95248 12.5778 3.03798 12.6763ZM11.5776 13.9138L9.98103 12.3312C9.84603 12.1728 9.84603 11.9712 9.84603 11.9712C9.84603 11.9712 9.83703 11.7732 9.98103 11.6112C10.287 11.2534 11.106 10.4547 11.5776 10.0286C11.7689 9.85035 11.8148 9.73785 11.8148 9.51915V7.095C11.8148 6.99735 11.7009 6.9366 11.6123 7.0185C10.5701 7.9833 8.24898 10.2837 7.47093 11.1747C7.09833 11.5693 7.13343 11.9712 7.13343 11.9712C7.13343 11.9712 7.09923 12.3762 7.47093 12.7677C8.24943 13.6587 10.5759 15.9591 11.6123 16.9239C11.705 17.0049 11.8148 16.954 11.8148 16.8393V14.4197C11.8148 14.1946 11.7689 14.0866 11.5776 13.9093V13.9138ZM12.9479 13.9156L14.5445 12.333C14.6795 12.1746 14.6795 11.973 14.6795 11.973C14.6795 11.973 14.6885 11.775 14.5445 11.613C14.2385 11.2552 13.4195 10.4565 12.9479 10.0303C12.7566 9.85215 12.7107 9.73965 12.7107 9.52095V7.1085C12.7107 6.99375 12.8201 6.9429 12.9132 7.0239C13.9554 7.9887 16.2765 10.2891 17.0546 11.1801C17.4263 11.5747 17.3921 11.9766 17.3921 11.9766C17.3921 11.9766 17.4263 12.3816 17.0546 12.7731C16.2761 13.6641 13.9496 15.9645 12.9132 16.9293C12.8205 17.0103 12.7107 16.9594 12.7107 16.8447V14.4255C12.7116 14.2005 12.7566 14.0938 12.9479 13.9156Z" fill="white" />
    </svg>
)



/**
 * 
 * @param {{
 *   show: boolean,
 *   onHide: () => void,
 *   vehicles: {
 *     vin: string,
 *     display_name: string,
 *     make: 'tesla' | 'rivian',
 *     connected: boolean,
 *     can_enable: boolean,
 *     autopilot_analysis: {
 *       enabled: boolean,
 *       supported: boolean,
 *       can_enable: boolean,
 *       type: {
 *         full: string,
 *         short: string,
 *         type_key: string,
 *       },
 *     },
 *   }[],
 *   vehicle=string,
 *   onSwitchConnection: (vehicle: any) => void,
 *   onSwitchAutopilotAnalysis: (vehicle: any) => void,
 *   updating: {
 *     vin: string,
 *     type: 'vehicle_connection' | 'fsd_connection',
 *   }[],
 * }} props 
 * @returns 
 */
export default function VehicleManagementModal({ show, vehicles, onHide, vehicle, onSwitchConnection, onSwitchAutopilotAnalysis, updating }) {

    if (!Array.isArray(vehicles)) return false

    const selectedVehicle = vehicles?.find(v => v.vin === vehicle)

    const onSwitchConnectionInternal = () => {
        onSwitchConnection(selectedVehicle)
    }

    const onSwitchAutopilotAnalysisInternal = () => {
        onSwitchAutopilotAnalysis(selectedVehicle)
    }

    const isUpdatingConnection = updating.some(x => x.vin === selectedVehicle.vin && x.type === 'vehicle_connection')
    const isUpdatingFSD = updating.some(x => x.vin === selectedVehicle.vin && x.type === 'fsd_connection')

    return (
        <Modal show={show} onClose={onHide}>
            <Container>
                <BigRow>
                    <Row>
                        {selectedVehicle?.make === 'tesla' && <TeslaIcon />}
                        {selectedVehicle?.make === 'rivian' && <RivianIcon />}
                        <Text.Body variant='bold' color={styles.colors.dimHighlight}>{selectedVehicle?.display_name} Settings</Text.Body>
                    </Row>
                    <BlankButton onClick={onHide}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.27566 4.27566C3.90811 4.64322 3.90811 5.23914 4.27566 5.60669L10.1984 11.5294L4.27566 17.4521C3.90811 17.8197 3.90811 18.4156 4.27566 18.7832C4.64322 19.1507 5.23914 19.1507 5.60669 18.7832L11.5294 12.8604L17.5859 18.9169C17.9535 19.2845 18.5494 19.2845 18.9169 18.9169C19.2845 18.5494 19.2845 17.9535 18.9169 17.5859L12.8604 11.5294L18.7832 5.60669C19.1507 5.23914 19.1507 4.64322 18.7832 4.27566C18.4156 3.90811 17.8197 3.90811 17.4521 4.27566L11.5294 10.1984L5.60669 4.27566C5.23914 3.90811 4.64322 3.90811 4.27566 4.27566Z" fill="white" />
                        </svg>
                    </BlankButton>
                </BigRow>
                <BigRow>
                    <Text.Caption variant='bold'>Vehicle Connection</Text.Caption>
                    <Row>
                        <Text.Caption color={selectedVehicle?.connected ? styles.colors.success : styles.colors.lightGray} variant='bold'>{selectedVehicle?.connected ? 'Connected' : 'Disconnected'}</Text.Caption>
                        {isUpdatingConnection ? (
                            <Spinner animation='border' variant='light' style={{ marginLeft: '8px' }} />
                        ) : (
                                <StyledSwitch
                                    checked={selectedVehicle?.connected}
                                    onChange={onSwitchConnectionInternal}
                                    disabled={isUpdatingConnection}
                                />
                        )}
                    </Row>
                </BigRow>
                {selectedVehicle?.autopilot_analysis?.can_enable && (
                    <BigRow>
                        <Text.Caption variant='bold'>{selectedVehicle?.autopilot_analysis?.type?.full}</Text.Caption>
                        <Row>
                            <Text.Caption color={selectedVehicle?.autopilot_analysis?.enabled ? styles.colors.success : styles.colors.lightGray} variant='bold'>{selectedVehicle?.autopilot_analysis?.enabled ? 'Enabled' : 'Disabled'}</Text.Caption>
                            {isUpdatingFSD ? (
                                <Spinner animation='border' variant='light' style={{ marginLeft: '8px' }} />
                            ) : (
                                    <StyledSwitch
                                        checked={selectedVehicle?.autopilot_analysis?.enabled}
                                        onChange={onSwitchAutopilotAnalysisInternal}
                                        disabled={isUpdatingFSD}
                                    />
                            )}
                        </Row>
                    </BigRow>
                )}
            </Container>
        </Modal>
    )
}